import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CHeader,
	CHeaderNav,
	CHeaderToggler,
	CHeaderDivider,
	CHeaderBrand,
	CFooter,
	CRow,
	CCol,
	CContainer,
	CForm,
	CFormInput,
	CFormTextarea,
	CInputGroup,
	CInputGroupText,
	CCard,
	CCardHeader,
	CCardBody,
	CCardFooter,
	CImage,
	CLink,
	CTooltip,
	CSpinner,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { isMobile } from "react-device-detect";
import NumberFormat from 'react-number-format';
import {
	MyPagination,
	MyProfileDetil,
	MyPage500,
} from '../components/index'
import { Konfirm } from '../helpers/onConfirm'
import { UFunc } from '../helpers/functions'

const pjson 		= require('../../package.json')
const Updatedlogs 	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props;
	const { id } 			= useParams(); 

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uIsEOMExecuted			= useSelector(state => state.gIsEOMExecuted);

	const [uEfekview,setEfekview] 	= React.useState(false);
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 10) : (uSettingObj.jml_tabel || 20);
	const [uPageActive,setPageActive]		= React.useState(1);
	const [uJmlHal,setJmlHal] 				= React.useState(1);
	const [uISBacktriggered,setBacktriggered] = React.useState(false);
	/*const uKeywordObj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uIsHapusallow				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN") ? true : false;
	const [uHTMLError500,setHTMLError500]	= React.useState();
	const [uTimeelapse,setTimeelapse]		= React.useState(0); 

	const [uDatamainObj,setDatamainObj]		= React.useState({})//-*/

	//--DLG_FORM--/
	//--END DLG_FORM--/

	const uDatalogsArr	= [
		{version:"1.30.1",updated_arr:[
			{teks_menu:"App",teks_content:"Update Fitur, Pindah Server Cloud.<br/>Penyesuaian Kode untuk UPLOAD Foto dan Dokumen, terutama untuk sinkronisasi folder."},
		],tgl_updated:"2026-10-10"},
		{version:"1.30.0",updated_arr:[
			{teks_menu:"Klinik >> Data Pasien >> Lihat Rekam Medis",teks_content:"Update Fitur, Penambahan Fitur Update Layanan Lama."},
			{teks_menu:"Kasir >> Copy Nota",teks_content:"Update Fitur, Nilai Total Harus Dikurangi Diskon Dahulu."},
			{teks_menu:"Operasional >> Purchasing >> Pembelian Barang >> Form Pembelian",teks_content:"Update BUG, Pembetulan Nota dan Supplier Tidak Bisa Diinput SPASI."},
			{teks_menu:"Operasional >> Inventaris >> Pembelian Aset >> Form Pembelian Aset",teks_content:"Update FITUR, Ketika Pembayaran NOL, tidak perlu memasukkan Kas Asal Pembayaran."},
		],tgl_updated:"2026-08-19"},
		{version:"1.29.0",updated_arr:[
			{teks_menu:"Operasional >> Hutang >> H.Supplier >> Preview Item",teks_content:"Update Fitur, Menampilkan Detil item Seperti Menu Purchasing."},
			{teks_menu:"Stok >> Stok Opname",teks_content:"Update Fitur, Mengubah metode Loading Data, karena BIG Data."},
		],tgl_updated:"2026-06-18"},
		{version:"1.28.0",updated_arr:[
			{teks_menu:"Operasional >> Purchasing >> Request Order >> Form Barang Datang",teks_content:"Update FITUR, Menambahkan Upload PDF Trx Pembelian, disamakan dengan Menu Pembelian BARANG."},
		],tgl_updated:"2026-04-28"},
		{version:"1.27.0",updated_arr:[
			{teks_menu:"Operasional >> Purchasing >> Request Order >> Form Barang Datang",teks_content:"Update FITUR, Batch Number Bisa Tanpa Diisi.<br/>Fixing BUG jika Jumlah Sama, tapi Nama Barang berbeda."},
			{teks_menu:"Operasional >> Purchasing >> Pembelian Barang",teks_content:"Update BUG, Data Validasi Tahun Lewat Tetap Ditampilkan, ketika tanpa KEYWORD."},
			{teks_menu:"Master Data >> Pengguna Aplikasi",teks_content:"Update Fitur, Tambah Hak User 'ADMIN KHUSUS'."},
			{teks_menu:"Master Data >> Master Barang",teks_content:"Update Fitur, Hak Admin Khusus Dapat Merubah Harga."},
			{teks_menu:"Master Data >> Master Jasa",teks_content:"Update Fitur, Hak Admin Khusus Dapat Merubah Harga."},
			{teks_menu:"API >> Tutup Periode",teks_content:"Update Fitur, Ketika EOM Bulan 12 HPP Masih Di-NOL-kan.<br/>Ketika EOY, Re-check L/R Bulan ini untuk Mengulang EOM Terlebih Dahulu."},
			{teks_menu:"API >> Lap.Buku Besar",teks_content:"Update BUG, Tahun Lampau dari Data yang sudah DORMANT Tidak Ter-load."},
		],tgl_updated:"2026-01-11"},
		{version:"1.26.1",updated_arr:[
			{teks_menu:"Operasional >> Purchasing >> Request Order >> Form Barang Datang",teks_content:"Update FITUR, Catatan/Note Order harus Bisa Diupdate disini."},
			{teks_menu:"API >> Jurnal >> Modul Pelunasan Piutang",teks_content:"Update BUG, Fixing Proses Jurnal PYAD Barang ketika sudah lewat tahun, harus mengambil data yang sudah DORMANT."},
			{teks_menu:"API >> Pecah Box",teks_content:"Update BUG, Fixing Pembulatan HPP Ketika HPP Barang Pecahan Tidak Bulat."},
		],tgl_updated:"2025-12-24"},
		{version:"1.26.0",updated_arr:[
			{teks_menu:"Operasional >> Purchasing >> Request Order",teks_content:"Update FITUR, Tambah Fitur Catatan Order ditaruh disebelah PEMBUAT ORDER."},
			{teks_menu:"Operasional >> Purchasing >> Request Order >> Form RO",teks_content:"Update FITUR, Tambah Fitur Catatan Order ditaruh dibawah PEMBUAT ORDER."},
			{teks_menu:"Operasional >> Purchasing >> Request Order >> Form Barang Datang",teks_content:"Update FITUR, Tambah Fitur Data-data Pembayaran Pembelian seperti Fitur Input Pembelian.<br/>"+
				"Update BUG, QTY Datang NOL Harus Bisa tanpa Batch, dan Tidak perlu dikirim sebagai pembelian."+
				""},
			{teks_menu:"Setting >> Kustomisasi Data >> Pecah Data Tahunan",teks_content:"Update FITUR, Proses Dormant Data untuk Data Jurnal dan Stok pada Tahun-tahun Sebelumnya, agar Proses Operasional Transaksi pada Tahun ini Lebih Optimal."},
		],tgl_updated:"2025-12-14"},
		{version:"1.25.0",updated_arr:[
			{teks_menu:"Operasional >> Purchasing >> Request Order",teks_content:"Update FITUR, Tambah Fitur List Input Request Order."},
			{teks_menu:"Operasional >> Purchasing >> Request Order >> Form RO",teks_content:"Update FITUR, Tambah Fitur Untuk Input dan Revisi Request Order."},
			{teks_menu:"Operasional >> Purchasing >> Request Order >> Form Barang Datang",teks_content:"Update FITUR, Tambah FORM Untuk Input Barang Datang dan Otomatis Masuk Pembelian."},
			{teks_menu:"Operasional >> Purchasing >> Pembelian Barang >> Form Pembelian",teks_content:"Update FITUR, Menerima Input dari Barang Datang menu Request ORDER.<br/>Perbaikan BUG File PDF ketika EDIT, HOST URL invalid."},
			{teks_menu:"APP >> All Form",teks_content:"Update FITUR, Melakukan Disable Fitur Auto Complete Input Form, agar autocomplete tidak mengganggu proses Lookup Data."},
		],tgl_updated:"2025-12-01"},
		{version:"1.24.2",updated_arr:[
			{teks_menu:"Operasional >> Hutang >> H.Supplier >> Preview Pembayaran",teks_content:"Update Fitur, Menampilkan Nilai Deposit Sisa Retur yang Digunakan ketika Pembayaran."},
		],tgl_updated:"2025-11-12"},
		{version:"1.24.1",updated_arr:[
			{teks_menu:"Application",teks_content:"Update BUG, Perbaikan Notification Toast yang Tidak Bisa Hilang jika Dimunculkan Bersamaan."},
			{teks_menu:"Kasir >> Kasir Klinik >> Form Bayar",teks_content:"Update Fitur, Penambahan Fitur Jika Koneksi tiba-tiba terputus, dan tidak diketahui apakah Proses Bayar berhasil dilakukan, maka dialihkan ke halaman sebelumnya."},
			{teks_menu:"Kasir >> Kasir Toko >> Form Bayar",teks_content:"Update Fitur, Penambahan Fitur Jika Koneksi tiba-tiba terputus, dan tidak diketahui apakah Proses Bayar berhasil dilakukan, maka dialihkan ke halaman sebelumnya."},
			{teks_menu:"Kasir >> Copy Nota >> API Penghapusan",teks_content:"Update Fitur, Penambahan Fitur Hapus Otomatis Pembayaran Hutang JPL yang dihapus."},
		],tgl_updated:"2025-11-04"},
		{version:"1.24.0",updated_arr:[
			{teks_menu:"Operasional >> Inventaris dan Aset >> Pembelian Aset >> Form Pembelian",teks_content:"Update BUG, Perbaikan Ketika Konfirmasi Simpan, Nama Supplier Tidak Muncul."},
			{teks_menu:"Kasir >> Kasir Piutang",teks_content:"Update Fitur, Penambahan Fitur Transfer PIUTANG USAHA KHUSUS dengan Jurnal yang Baru."+
				"<br/>Penambahan Fitur Penghapusan PIUTANG, berserta Jurnal barunya."},
			{teks_menu:"Operasional >> Purchasing >> Pembelian Barang",teks_content:"Update FITUR, Memindahkan Card Data Nilai Summary dibawah Card Tabel Item."},
		],tgl_updated:"2025-10-15"},
		{version:"1.23.0",updated_arr:[
			{teks_menu:"Master Data >> Master Barang",teks_content:"Update FiTUR, Input Nama Barang dibuat Tidak Otomatis Capitalize."},
			{teks_menu:"Master Data >> Master Jasa",teks_content:"Update FiTUR, Input Nama Jasa dibuat Tidak Otomatis Capitalize."},
			{teks_menu:"Master Data >> Master Klien",teks_content:"Update BUG, Perbaikan BUG saat Keyword Tidak Diisi, Input ERROR."},
			{teks_menu:"Klinik >> Pasien Dalam Proses >> Form Pemeriksaan",teks_content:"Update FiTUR, Pada saat penambahan Item Terapi PIHAK LAIN, perlu ditambahkan SIGN bahwa Supplier Pihak Lain belum Terpilih Dengan Benar."},
			{teks_menu:"Kasir >> Kasir Piutang",teks_content:"Update Fitur, Perubahan Tampilan Detil Transaksi, dengan menggabungkan Nota Transaksi dan Pembayaran."},
			{teks_menu:"Klinik >> Data Pasien >> Lihat Rekam Medis >> Detil Rekam Medis",teks_content:"Update Fitur, Upload PDF File Untuk Kunjungan Pasien."},
		],tgl_updated:"2025-09-30"},
		{version:"1.22.0",updated_arr:[
			{teks_menu:"Kasir >> Kasir TOKO",teks_content:"Update BUG, Perbaikan Navigasi Kasir Toko, akibat adanya pembaruan ROUTER, karena harus DIRESET dahulu."},
			{teks_menu:"Laporan >> Cocokan >> Lap.Piutang PUK",teks_content:"Update Fitur, Penambahan Fitur Laporan Piutang Usaha Khusus dengan Format yang Telah ditentukan sebelumnya."},
			{teks_menu:"Api >> Lap.Hutang",teks_content:"Update BUG, Variabel Selisih Tagihan Belum dimasukkan."},
			{teks_menu:"Api >> Lap.HTJPL",teks_content:"Update BUG, Penghapusan yang dilakukan Bulan Ini, namun diinput bulan sebelumnya, mengakibatkan selisih dengan Buku Besar."},
		],tgl_updated:"2025-09-11"},
		{version:"1.21.1",updated_arr:[
			{teks_menu:"Laporan >> Cocokan >> Lap.PYAD JPL PUK",teks_content:"Update Fitur, Penambahan Fitur Lap.PYAD JPL Piutang Usaha Khusus dengan Format yang Telah ditentukan sebelumnya."},
		],tgl_updated:"2025-08-31"},
		{version:"1.21.0",updated_arr:[
			{teks_menu:"Laporan >> Cocokan >> Lap.HTPS PUK",teks_content:"Update Fitur, Laporan baru untuk HTPS Piutang Usaha Khusus."},
			{teks_menu:"Laporan >> Cocokan >> Lap.PYAD",teks_content:"Update Fitur, Kolom PYAD HTPS, PYAD JPL, dan Sisa Piutang Belum Muncul Ketika CETAK dan Export-to-Excel."},
			{teks_menu:"Laporan >> Cocokan >> Lap.PYAD PUK",teks_content:"Update Fitur, Laporan baru untuk PYAD Piutang Usaha Khusus."},
		],tgl_updated:"2025-08-26"},
		{version:"1.20.3",updated_arr:[
			{teks_menu:"Laporan >> Cocokan >> Lap.PYAD",teks_content:"Update Fitur, Penambahan Kolom PYAD HTPS, PYAD JPL, dan Sisa Piutang."},
			{teks_menu:"Api >> Pembelian Barang",teks_content:"Update BUG, Variabel Harga pada saat pembelian Salah."},
			{teks_menu:"Api >> Reklas Barang Mutasi",teks_content:"Update BUG, Mengubah satu-per-satu proses Penghapusan, karena sebelumnya menyebabkan qty awal dan akhir tidak valid."},
		],tgl_updated:"2025-08-23"},
		{version:"1.20.2",updated_arr:[
			{teks_menu:"Laporan >> Cocokan >> Lap.PYAD JPL",teks_content:"Update Fitur, Penambahan Fitur Lap.PYAD JPL dengan Format yang Telah ditentukan sebelumnya."},
			{teks_menu:"Api >> Jurnal",teks_content:"Update BUG, Pembetulan Jurnal Pendapatan, Ketika ada pembayaran sebagian kurang jurnal HTPS dan PYAD HTPS."},
		],tgl_updated:"2025-08-11"},
		{version:"1.20.1",updated_arr:[
			{teks_menu:"Laporan >> Cocokan >> Lap.PYAD",teks_content:"Update Fitur, Perubahan Format Laporan dari per Nota menjadi per Customer dengan Jumlah Nota."},
			{teks_menu:"Laporan >> Cocokan >> Lap.Hutang JPL",teks_content:"Update Fitur, Penambahan Kolom Format Laporan dengan menambahkan Customer dan Tanggal Awal."},
		],tgl_updated:"2025-08-07"},
		{version:"1.19.2",updated_arr:[
			{teks_menu:"General Aplikasi",teks_content:"Update Fitur, Menambahkan Fitur Geo Lokasi, untuk pelacakan Lokasi Penggunakan Aplikasi."},
			{teks_menu:"Api >> Barang Mutasi",teks_content:"Update Fitur, Mengubah Jenis Barang sesuai update terakhir, tidak ikut Jenis Barang ketika PEMBELIAN."},
			{teks_menu:"Api >> Jurnal",teks_content:"Update BUG, Pembetulan Jurnal Pelunasan Piutang, karena kesalahan pengambilan Data PYAD Diskon."},
			{teks_menu:"Api >> Lap.HTPS",teks_content:"Update BUG, Pembetulan Filter Tanggal yang Salah penulisan Kode Program."},
			{teks_menu:"Operasional >> Inventaris dan Aset >> Pembelian Aset >> Form Pembelian",teks_content:"Update BUG, Pembetulan Ketika Klik BACK tidak dapat kembali."},
		],tgl_updated:"2025-08-04"},
		{version:"1.19.1",updated_arr:[
			{teks_menu:"Klinik >> Pasien Dalam Proses >> Form Pemeriksaan",teks_content:"Update BUG, Perbaikan ketika Tambah Item On Enter, List Item Hilang.<br/>Memperbaiki Error ketika DONE."},
		],tgl_updated:"2025-07-15"},
		{version:"1.19.0",updated_arr:[
			{teks_menu:"Kasir >> Copy Nota",teks_content:"Update FiTUR, Memunculkan METODE PEMBAYARAN karena sebelumnya Tidak Ada.<br/>Tutup Nota Otomatis, Kasir-nya diisi User Penanggung Jawab Pertama."},
			{teks_menu:"Klinik >> Data Pasien >> Lihat Rekam Medis",teks_content:"Update BUG, Memperbaiki Navigasi Halaman, yang Tidak Muncul ketika menggunakan perangkat MOBILE."},
			{teks_menu:"Klinik >> Pasien Dalam Proses >> Form Pemeriksaan",teks_content:"Update BUG, Ketika Menggunakan Tablet, Harga Satuan Menjadi NOL.<br/>Cek Stok Item Treatment Invalid."},
			{teks_menu:"Login",teks_content:"Update Fitur, Notifikasi Password Tidak Aman."},
			{teks_menu:"Api >> Cek Password",teks_content:"Update Fitur, Validasi Password untuk alasan KEAMANAN."},
		],tgl_updated:"2025-07-10"},
		{version:"1.18.1",updated_arr:[
			{teks_menu:"Kasir >> Kasir TOKO",teks_content:"Update BUG, Perbaikan Navigasi Kasir Toko, akibat adanya pembaruan ROUTER."},
		],tgl_updated:"2025-05-30"},
		{version:"1.18.0",updated_arr:[
			{teks_menu:"Laporan >> Operasional >> Lap.Piutang",teks_content:"Update Fitur, Manambahkan Kolom Data Tgl Bayar Terakhir untuk Analisa Piutang Customer."},
		],tgl_updated:"2025-05-30"},
		{version:"1.17.2",updated_arr:[
			{teks_menu:"Operasional >> Purchasing >> Pembelian Barang >> Form Pembelian",teks_content:"Update BUG, Kesalahan Perhitungan Deposit Supplier yang Dipakai."},
		],tgl_updated:"2025-05-28"},
		{version:"1.17.1",updated_arr:[
			{teks_menu:"Klinik >> Pasien Dalam Proses >> Form Pemeriksaan",teks_content:"Update BUG, Ketika Proses DONE Selesai, Tidak Dapat Kembali ke Halaman Sebelumnya."},
		],tgl_updated:"2025-05-26"},
		{version:"1.17.0",updated_arr:[
			{teks_menu:"Operasional >> Purchasing >> Pembelian Barang",teks_content:"Update FITUR, View Tgl Nota dan Tgl Input.<br/>View Foto Dokumen Pembelian dan PDF Dokumen Pembelian."},
			{teks_menu:"Operasional >> Purchasing >> Pembelian Barang >> Form Pembelian",teks_content:"Update FITUR, Tambah Tgl Nota dan Tgl Input.<br/>Tambah Input Foto Dokumen Pembelian dan PDF Dokumen Pembelian.<br/>Deposit Supplier Dapat ditentukan secara fleksibel."},
		],tgl_updated:"2025-05-25"},
		{version:"1.16.0",updated_arr:[
			{teks_menu:"Login",teks_content:"Update Fitur, Menambahkan SHOW-HIDE Password."},
			{teks_menu:"Operasional >> Karyawan >> PAYROLL >> Detil Payroll",teks_content:"Update FITUR, Membuat Header Kolom Sticky to the top, ketika scrolling."},
			{teks_menu:"Operasional >> Tutup Periode",teks_content:"Update FITUR, Menambahkan Fitur Re-process API untuk Proses Pendapatan dan Piutang."},
		],tgl_updated:"2025-05-09"},
		{version:"1.15.2",updated_arr:[
			{teks_menu:"Operasional >> Tutup Periode",teks_content:"Update BUG, Proses EOM Penyusutan dan Adjustment Belum Ditambahkan di EOM Sekuensial."},
		],tgl_updated:"2025-04-30"},
		{version:"1.15.1",updated_arr:[
			{teks_menu:"Kasir >> Kasir Klinik >> Form Pembayaran",teks_content:"Update FITUR, Menambahkan Fitur Konfirmasi Jika Ternyata Nota Sudah Diinputkan, untuk mengantisipasi Klik Bayar 2x."},
		],tgl_updated:"2025-04-30"},
		{version:"1.15.0",updated_arr:[
			{teks_menu:"Laporan >> Operasional >> Lap.PYAD",teks_content:"Update Fitur, Melengkapi Laporan Cocokan untuk Lap.PYAD."},
			{teks_menu:"Laporan >> Operasional >> Lap.HTPS",teks_content:"Update BUG, Laporan HTPS ERROR pada level Server karena Case Sensitive."},
			{teks_menu:"CRONJOB >> Adjustment HPP",teks_content:"Update Fitur, Untuk Bulan 12 HPP Tidak Perlu dilakukan Adjustment."},
			{teks_menu:"CRONJOB >> Adjustment HPP",teks_content:"Update BUG, HPP Setelah EOY yang sudah menjadi NOL, harus disertakan."},
			{teks_menu:"Operasional >> Keuangan",teks_content:"Update Fitur, Status TEMBAK DATA untuk Hari Ini di-ENABLED, sebelumnya DISABLED."},
		],tgl_updated:"2025-04-25"},
		{version:"1.14.6",updated_arr:[
			{teks_menu:"Operasional >> Tutup Periode",teks_content:"Update Fitur, Merubah Proses EOD menjadi Proses Sekuensial dari sebelumnya Proses Paralel.<br/>Merubah Proses EOM menjadi Proses Sekuensial dari sebelumnya Proses Paralel"},
			{teks_menu:"Operasional >> Purchasing >> Pembelian Barang >> Form Pembelian",teks_content:"Update BUG, Perbaikan Field Tanggal Expired, ketika EDIT Item Barang."},
			{teks_menu:"Kasir >> Kasir Klinik >> Form Pembayaran",teks_content:"Update BUG, Perbaikan Api Ketika Ada nilai DP Customer, Jika Nilai Transaksi Lebih dari Nilai DP, Nilai DP tidak BERKURANG."},
			{teks_menu:"Klinik >> Data Pasien >> Lihat Rekam Medis",teks_content:"Update FITUR. Mencantumkan No.Nota dan Nama Item Cetak dan Nama Item Master Data."},
		],tgl_updated:"2025-04-25"},
		{version:"1.14.5",updated_arr:[
			{teks_menu:"Kasir >> Kasir Klinik",teks_content:"Update Fitur, Ketika KLIK ADA PIUTANG, diberi atribut ID Customer Agar Keyword Customer Lain tidak perlu tampil."},
			{teks_menu:"Kasir >> Kasir Klinik >> Form Pembayaran",teks_content:"Update BUG, Ketika menambahkan Item Pihak Lain, Status Lunas/Tidak Lunas Bermasalah."},
			{teks_menu:"Kasir >> Kasir Piutang",teks_content:"Update Fitur, Search dengan Kondisi Khusus, dapat menampilkan atribut ID Customer Agar Keyword Customer Lain tidak perlu tampil."},
			{teks_menu:"Klinik >> Data Pasien >> Lihat Rekam Medis",teks_content:"Update BUG. Tanggal Reminder Tidak Dapat Berubah, ketika diketik manual."},
		],tgl_updated:"2025-04-17"},
		{version:"1.14.4",updated_arr:[
			{teks_menu:"Dashboard",teks_content:"Update FITUR, Menambahkan tombol REFRESH Grafik Omzet, PIE Omzet belum RE-LOAD."},
			{teks_menu:"Master Data >> Data Jasa",teks_content:"Update Fitur, menampilkan Seluruh Data Meskipun tidak memasukkan KEYWORD."},
			{teks_menu:"Kasir >> Kasir Klinik >> Form Input",teks_content:"Update BUG, Memperbaiki Total Transaksi disamakan dengan Total Item."},
		],tgl_updated:"2025-03-28"},
		{version:"1.14.3",updated_arr:[
			{teks_menu:"Dashboard",teks_content:"Update FITUR, Menambahkan tombol REFRESH untuk beberapa CARD."},
			{teks_menu:"Klinik >> Reminder",teks_content:"Update FITUR, Mengubah Tampilan Bulan ini Yang Tanggal-nya Sudah Lewat."},
			{teks_menu:"Kasir >> Kasir Klinik",teks_content:"Update BUG, Perbaikan Ketika Ada DP tapi Tidak Ada Kembalian, Harusnya Bisa DISIMPAN."},
		],tgl_updated:"2025-03-09"},
		{version:"1.14.1",updated_arr:[
			{teks_menu:"Master Data >> Data Klien",teks_content:"Update BUG, menambahkan inisialisasi Change value Form."},
			{teks_menu:"Kasir >> Kasir Klinik",teks_content:"Update BUG, Keyword Piutang Format Berubah, menyesuaikan update terbaru."},
		],tgl_updated:"2025-02-06"},
		{version:"1.14.0",updated_arr:[
			{teks_menu:"Master Data >> Data Klien",teks_content:"Update Fitur, menambahkan TIPE PENAGIHAN Customer."},
			{teks_menu:"Laporan >> Operasional >> Lap.Piutang",teks_content:"Update Fitur, Menambahkan Fitur Filter Tipe Penagihan Customer, dan Menampilkan OUTPUT dengan Penyesuaian Filter Tersebut."},
			{teks_menu:"Laporan >> Operasional >> Lap.Kasir",teks_content:"Update Fitur, Menambahkan Filter REKAP HARIAN, dan Menampilkan OUTPUT dengan Penyesuaian Filter Tersebut."},
			{teks_menu:"Operasional >> Purchasing >> Pembelian Barang >> Form Pembelian",teks_content:"Update FITUR, Penambahan Item Pembelian dengan Nama SAMA, dengan HARGA ato EXP-DATE Berbeda."},
			{teks_menu:"Kasir >> Titipan Uang Muka",teks_content:"Update FITUR, Tampilan LIHAT DETIL diubah menjadi tampilan historikal per transaksi.<br/>Tiap Customer Ditambah Tombol Tambah yang langsung merujuk ke customer tersebut."},
			{teks_menu:"Kasir >> Titipan Uang Muka >> Form Tambah DP",teks_content:"Update FITUR, Form DP langsung merujuk ke Customer tersebut ketika Klik Tambah Customer."},
			{teks_menu:"Operasional >> Karyawan >> Payroll >> Form Payroll",teks_content:"Update FITUR, Cetak Slip Gaji diganti Cetak Rekap Payroll Bulanan."},
		],tgl_updated:"2025-02-03"},
		{version:"1.13.2",updated_arr:[
			{teks_menu:"Operasional >> Tutup Priode",teks_content:"Update LOG yang muncul untuk keperluan DEBUGGING."},
			{teks_menu:"Operasional >> Inventaris dan Aset >> Pembelian Aset >> Form Pembelian",teks_content:"Update BUG, Ketika Pilih Supplier Masih Tidak TerSET ID SUPPLIER-nya."},
			{teks_menu:"Kasir >> Copy Nota",teks_content:"Update FITUR, Admin Dapat Menampilkan NOTA Bulan Sebelumnya."},
			{teks_menu:"Kasir >> Kasir Piutang",teks_content:"Update FITUR, Pencarian Menggunakan Angka, untuk Nilai Sisa / Bayar / Nilai Piutang."},
		],tgl_updated:"2025-01-11"},
		{version:"1.13.1",updated_arr:[
			{teks_menu:"Operasional >> Tutup Priode",teks_content:"Update FITUR, Penambahan Input PPh Ps25/29 Saat EOY.<br/>Update Api Tutup Periode."},
		],tgl_updated:"2025-01-06"},
		{version:"1.13.0",updated_arr:[
			{teks_menu:"Operasional >> Purchasing >> Pembelian Barang",teks_content:"Update FITUR, Perbaikan Tampilan Mobile."},
			{teks_menu:"Operasional >> Purchasing >> Pembelian Barang >> Form Pembelian",teks_content:"Update FITUR, Perbaikan Urutan Item sesuai Input.<br/>Perbaikan BUG jika Ada Deposit Supplier."},
			{teks_menu:"Operasional >> Purchasing >> Retur Pembelian",teks_content:"Update FITUR, Penambahan Fitur RETUR PEMBELIAN."},
			{teks_menu:"Operasional >> Purchasing >> Retur Pembelian >> Form Retur Pembelian",teks_content:"Update FITUR, Penambahan Fitur INPUT RETUR PEMBELIAN."},
			{teks_menu:"Operasional >> Tutup Periode",teks_content:"Update FITUR, Penambahan Proses EOD untuk Retur Pembelian."},
			{teks_menu:"Laporan >> Keuangan >> Lap.Neraca",teks_content:"Update BUG, Opsi Jenis Laporan jika Setelah EOY."},
		],tgl_updated:"2024-12-24"},
		{version:"1.12.0",updated_arr:[
			{teks_menu:"Klinik >> Pasien Dalam Proses >> Form Pemeriksaan",teks_content:"Update Fitur, Edit Label Item Terapi Untuk Keperluan Cetak Nota."},
			{teks_menu:"Operasional >> Purchasing >> Pembelian Barang",teks_content:"Update FITUR, Ubah Format Kolom dan Fitur Validasi.<br/>Form Validasi Input Pembelian."},
			{teks_menu:"Operasional >> Purchasing >> Pembelian Barang >> Form Pembelian",teks_content:"Update FITUR, Ubah Format Kolom Item Barang.<br/>Update Metode Reset.<br/>Pembayaran Kosong, Tidak perlu Memilih KAS.</br>Fitur Koreksi Sebelum Validasi Approval."},
		],tgl_updated:"2024-12-15"},
		{version:"1.11.0",updated_arr:[
			{teks_menu:"Klinik >> Pasien Dalam Proses >> Form Pemeriksaan",teks_content:"Update BUG, Item PIHAK LAIN, Harus Mencantumkan Kas Pambayaran ketika Sudah dibayarkan ke SUPPLIER."},
			{teks_menu:"Kasir >> Kasir Klinik >> Form Pembayaran",teks_content:"Update BUG, Item PIHAK LAIN, Harus Mencantumkan Kas Pambayaran ketika Sudah dibayarkan ke SUPPLIER."},
			{teks_menu:"Operasional >> Purchasing >> Pembelian Barang >> Form Pembelian",teks_content:"Update BUG, Memperbaiki Metode Counter Session."},
		],tgl_updated:"2024-12-11"},
		{version:"1.10.0",updated_arr:[
			{teks_menu:"Kasir >> Kasir Toko",teks_content:"Update Fitur, Jika NILAI PEMBAYARAN NOL, Tidak Perlu Memasukkan Metode Pembayaran."},
			{teks_menu:"Kasir >> Kasir Klinik >> Form Pembayaran",teks_content:"Update Fitur, Jika NILAI PEMBAYARAN NOL, Tidak Perlu Memasukkan Metode Pembayaran."},
			{teks_menu:"Laporan >> Inventori >> Lap.Histori Stok",teks_content:"Update Fitur, Laporan Histori Stok Sesuai Dengan Sistem yang Lama."},
			{teks_menu:"Laporan >> Laporan Cocokan >> Lap.Penyusutan",teks_content:"Update Fitur, Laporan Penyusutan Sesuai Dengan Sistem yang Lama."},
		],tgl_updated:"2024-11-30"},
		{version:"1.9.2",updated_arr:[
			{teks_menu:"Kasir >> Kasir Piutang",teks_content:"Update FITUR, JUMLAH Transaksi JUGA ditampilkan Di bawah rincian Item Terapi."},
			{teks_menu:"Master Data >> Pengguna Aplikasi",teks_content:"Update Minor, Memperbaiki Tampilan MINOR, dan standarisasi Kode Program."},
			{teks_menu:"Master Data >> Pengguna Aplikasi >> Set Individual ROLE",teks_content:"Update Fitur, Setting Individual ROLE per User yang tertunda."},
		],tgl_updated:"2024-11-19"},
		{version:"1.9.1",updated_arr:[
			{teks_menu:"Operasional >> Purchasing >> Pembelian Barang >> Form Pembelian",teks_content:"Update BUG, Lookup Supplier, ketika hanya SATU SUPPLIER, id-nya Tidak Terpilih dengan Benar."},
			{teks_menu:"Kasir >> COPY NOTA",teks_content:"Update Fitur, Hapus NOTA yang S.Jurnal BELUM DONE, dikembalikan ke KASIR KLINIK."},
			{teks_menu:"Kasir >> Kasir Klinik",teks_content:"Update BUG, Jika Ada Transaksi Pihak Lain, CRONJOB Belum memproses NAMA-NAMA Pasien.<br/>Perbaikan Ketika MULTIPLE Pasien, Kadang tidak Menjadi Satu Grup Customer."},
			{teks_menu:"Laporan >> Operasional >> Lap.Kasir",teks_content:"Update BUG, Jika Pembayaran Pasien NOL, yang MUNCUL seharusnya NILAI BAYAR Bukan Nilai Transaksi."},
		],tgl_updated:"2024-11-12"},
		{version:"1.9.0",updated_arr:[
			{teks_menu:"Stok >> Stok Opname",teks_content:"Update Akses Untuk Input Stok Opname, hanya untuk SUPERUSER dan SUPERVISOR."},
			{teks_menu:"Laporan >> Operasional >> Lap.Penjualan",teks_content:"Update Fitur Laporan Penjualan dengan Item Penjualannya."},
			{teks_menu:"Laporan >> Laporan Cocokan >> Lap.Uang Muka",teks_content:"Update Fitur Laporan Uang Muka per Bulan."},
		],tgl_updated:"2024-11-02"},
		{version:"1.8.0",updated_arr:[
			{teks_menu:"Klinik >> Data Pasien >> Edit Data Pasien",teks_content:"Update Upload Foto. <br/>Resize Foto Sebelum upload."},
			{teks_menu:"Klinik >> Data Pasien >> Card Profil Pasien",teks_content:"Update Fitur Foto Dapat Diperbesar."},
			{teks_menu:"Klinik >> Data Pasien >> Lihat Rekam Medis >> Detil Rekam Medis",teks_content:"Update Upload Foto. Fitur Multiple File dalam SATU Sesi Upload.<br/>Resize Foto Sebelum upload."},
			{teks_menu:"Klinik >> Pasien Dalam Proses >> Input Pemeriksaan",teks_content:"Update Upload Foto. Fitur Multiple File dalam SATU Sesi Upload.<br/>Resize Foto Sebelum upload."},
			{teks_menu:"Kasir >> Kasir Klinik >> Input Pembayaran",teks_content:"Perbaikan BUG, Nilai Bruto dan Jumlah Nilai Item Tidak Sama, Harus TIDAK BISA Disimpan.<br/>Update BUG Ketika Simpan Bayar, Foto Ketika Dalam Proses Dipindah ke Data Rekam Medis."},
			{teks_menu:"Laporan >> Operasional >> Lap.Kasir",teks_content:"Update Replace Laporan Pendapatan Menjadi Laporan Kasir."},
		],tgl_updated:"2024-10-23"},
		{version:"1.7.2",updated_arr:[
			{teks_menu:"Operasional >> Inventaris dan Aset >> Pembelian ASET >> Input Pembelian",teks_content:"Perbaikan BUG Ketika Menambahkan Supplier Baru."},
			{teks_menu:"Dashboard",teks_content:"Perbaikan BUG Api Top 5 Piutang Customer dan Top 5 Hutang Supplier."},
		],tgl_updated:"2024-10-15"},
		{version:"1.7.1",updated_arr:[
			{teks_menu:"Operasional >> Inventaris dan Aset >> Pembelian ASET >> Input Pembelian",teks_content:"Perbaikan BUG Sisa Piutang."},
			{teks_menu:"Operasional >> Inventaris dan Aset >> Pembelian ASET",teks_content:"Perbaikan BUG Terbayar Jika Pembelian Langsung Dilunasi."},
			{teks_menu:"Laporan >> Operasional >> Laporan Trx Customer",teks_content:"Update Fitur Detil Histori Pembayaran."},
			{teks_menu:"Laporan >> Inventori >> Laporan Mutasi Stok",teks_content:"Update Tambahan Fitur Laporan Mutasi Stok."},
			{teks_menu:"Laporan >> Keuangan >> Laporan Buku Besar",teks_content:"Request Update Fitur Dengan Filter Range Tanggal (Max:100 hari)."},
		],tgl_updated:"2024-10-09"},
		{version:"1.7.0",updated_arr:[
			{teks_menu:"Klinik >> Pasien >> Rekam Medis Pasien",teks_content:"Fitur Tambah/Edit/Hapus Reminder."},
			{teks_menu:"Operasional >> Hutang >> Hutang TJPL",teks_content:"Keterangan Transaksi Jasa Pihak Lain, Ditambah Nama Pasien."},
			{teks_menu:"Klinik >> Pasien Dalam Proses",teks_content:"BUG Kode Pasien Tidak Diisi Harus NULL."},
			{teks_menu:"Operasional >> Inventaris dan Aset >> Pembelian ASET >> Input Pembelian",teks_content:"Perbaikan Update tabel Item, menghapus Nilai NETTO, karena menimbulkan BUG. Cukup dengan JUMLAH TRANSAKSI saja."},
		],tgl_updated:"2024-10-03"},
		{version:"1.6.1",updated_arr:[
			{teks_menu:"Operasional >> Karyawan >> PAYROLL >> Detil Payroll",teks_content:"Koreksi Jurnal Reklas Tagihan BPJS.<br/>Mengaktifkan Fitur Export-to-Excel."},
		],tgl_updated:"2024-09-10"},
		{version:"1.6.0",updated_arr:[
			{teks_menu:"Update Logs",teks_content:"Menu Fitur Untuk menampilkan Log-log Perubahan pada Aplikasi."},
			{teks_menu:"Operasional >> Keuangan >> Biaya Perusahaan >> Input Biaya",teks_content:"Update Fitur Load GL Biaya Diperbaiki, sehinggga yang Baru masuk BIAYA OPERASIONAL.<br/>Update Default RESET dan BACK."},
			{teks_menu:"Operasional >> Tutup Periode",teks_content:"Tombol Fitur Untuk Pembatalan Status DALAM Proses EOD/EOM/EOY. Agar Transaksi Berikutnya Dapat Berjalan Kembali."},
			{teks_menu:"LAPORAN >> Operasional >> Lap.Hutang",teks_content:"Fitur Laporan Hutang Supplier Pembelian Barang dan Supplier Pembelian Aset."},
		],tgl_updated:"2024-09-06"},
		{version:"1.5.x",updated_arr:[
			{teks_menu:"Aplikasi",teks_content:"Seluruh Update Terakhir yang BELUM terdokumentasi."},
		],tgl_updated:"2024-09-03"},
	]
	const uJmlData	= uDatalogsArr.length;

	//---HANDEL--/
	//---END HANDEL--/

	//---INIT_PROCESS--/
	//---END INIT_PROCESS--/

	//---CONTENT--/
	const contentMain = () => {
		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);

		const vDataviewArr	= uDatalogsArr.slice(vMin,(vMax));

		return (
		<>
		{vDataviewArr.map((vItems,vKeys)=>{
			const vItemsArr	= vItems.updated_arr || [];

			return (
			<CCard className="mb-3 classcardbg" key={vKeys}>
			<CCardHeader className="d-flex justify-content-between">
				<div>Ver: <b>{vItems.version}</b></div>
				<div className="classfontsmaller"><small>{UFunc.HariAngka(vItems.tgl_updated)}</small></div>
			</CCardHeader>
			<CCardBody>
			<ul>
			{vItemsArr.map((vItemcontent,vKeycontent)=>{
				return (
				<li key={vKeycontent}>
					<div className="fw-bolder">{vItemcontent.teks_menu}</div>
					<small className="d-block fst-italic">{UFunc.renderHTML(vItemcontent.teks_content)}</small>
				</li>
				)//>
			})}
			</ul>
			</CCardBody>
			</CCard>
			)//>
		})}
		</>
		)//>
	}
	//---END CONTENT--/

	//---REST_API--/
	//---END REST_API--/

	//---EFFECT--/
	React.useEffect(()=>{})
	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		
		return () => { setPageActive(1); }
	},[])
	React.useEffect(()=>{
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);
		setPageActive(uPageActive<=0 ? 1 : uPageActive);
	},[uJmlData]);
	React.useEffect(()=>{
		if(!uISBacktriggered) return;
		setBacktriggered(false);

		uNavigate(-1);
	},[uISBacktriggered]);
	//---END EFFECT--/

	//console.log("(Updatedlogs) uNavigate => "+JSON.stringify(uNavigate))
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }

	return (
		<>
		<div className="wrapper d-flex flex-column min-vh-100 bg-transparent">
		<CHeader position="sticky" className="mb-4 p-0">
		<CContainer fluid className="classheadermain border-bottom"
			style={{height:64}}>
			<CHeaderToggler className="px-0" onClick={()=>setBacktriggered(true)}>
			<CIcon icon="cilArrowCircleLeft" className="align-middle me-2" height={30}/>
			</CHeaderToggler>

			<CHeaderBrand className="me-auto">
				<small className="fw-bolder">
				Updated Logs<span className="d-none d-md-inline ms-1">{pjson.name}</span>
				</small>
			</CHeaderBrand>

			<CHeaderNav className="">
				<MyProfileDetil {...props}/>
			</CHeaderNav>
		</CContainer>
		</CHeader>

		<div className="body flex-grow-1 px-1 px-md-2 px-lg-5">
		<CContainer xxl className="px-0 mb-3">
			{contentMain()}
			{(uJmlData > uMaxData) && (
			<CCard>
			<CCardBody>
				<MyPagination
					activePage={uPageActive}
					pages={uJmlHal}
					onActivePageChange={(i) => setPageActive(i)}/>
			</CCardBody>
			</CCard>
			)}
		</CContainer>
		</div>
		</div>
		</>
	) //>
}	

export default Updatedlogs